import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const ConversationWorkflowIndex = () => import('./index.vue');
const ConversationCategoriesIndex = () => import('./categories.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/conversations'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'conversation_settings_index',
          component: ConversationWorkflowIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'categories',
          name: 'conversation_categories_index',
          component: ConversationCategoriesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/conversation-workflow'),
      redirect: to => ({
        name: 'conversation_settings_index',
        params: { accountId: to.params.accountId },
      }),
    },
  ],
};
